export const LOGIN_TIMEOUT_MS = 15000;

export function getLoginErrorMessage(error) {
  if (error?.status === 'FETCH_ERROR' || error?.code === 'ERR_NETWORK') {
    return 'Cannot reach the server. Please try again.';
  }
  if (error?.status === 'TIMEOUT_ERROR' || error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
    return 'Login took too long. Please try again.';
  }
  if (error?.status === 429) return 'Too many login attempts. Please wait a moment and try again.';
  if (Number(error?.status) >= 500) return 'The login service is temporarily unavailable. Please try again.';
  const message = error?.data?.message || error?.data?.error?.message;
  if (typeof message === 'string' && message.trim()) return message;
  if (error?.status === 401) return 'Email or password is incorrect.';
  return 'Unable to log in. Please try again.';
}
